]<!-- =========================================================================================
    File Name: Faq.vue
    Description: FAQ Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="faq-page">
    <!-- JUMBOTRON -->
    <div class="faq-jumbotron">
      <div class="faq-jumbotron-content lg:p-32 md:p-24 sm:p-16 p-8 rounded-lg mb-base">
        <h1 class="mb-1 text-white">Have Any Questions?</h1>
        <p class="text-white">
          Below you can find the answers to the most frequently asked questions we’re getting from our first creators in
          Hoverlay. Hope you’ll find them useful.
        </p>
        <vs-input
          placeholder="Search"
          v-model="faqSearchQuery"
          icon-pack="feather"
          icon="icon-search"
          size="large"
          class="w-full mt-6"
          icon-no-border
        />
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full md:w-2/5 lg:w-1/4 rounded-lg">
        <vx-card>
          <h4>Table of Content</h4>
          <ul class="faq-topics mt-4">
            <li
              v-for="category in categories"
              :key="category.id"
              class="p-2 font-medium flex items-center"
              @click="faqFilter = category.id"
            >
              <div class="h-3 w-3 rounded-full mr-2" :class="'bg-' + category.color"></div>
              <span class="cursor-pointer">{{ category.name }}</span>
            </li>
          </ul>

          <!-- <br><br> -->
          <!-- <h4>Supporters</h4>
                    <ul class="faq-supporters mt-4">
                        <li v-for="supporter in supporters" :key="supporter.id" class="mt-4">
                            <div class="flex items-center">
                                <vs-avatar class="mr-3" :src="supporter.img" size="35px" />
                                <div class="leading-tight">
                                    <p class="font-semibold">{{ supporter.name }}</p>
                                    <small>{{ supporter.profession }}</small>
                                </div>
                            </div>
                        </li>
                    </ul> -->
        </vx-card>
      </div>

      <!-- FAQ COL -->
      <div class="vx-col w-full md:w-3/5 lg:w-3/4 mt-12 md:mt-0">
        <vs-collapse accordion type="margin" class="p-0">
          <vs-collapse-item
            v-for="(que, index) in filteredFaq"
            class="faq-bg rounded-lg"
            :class="{ 'mt-0': !index }"
            :key="que.id"
          >
            <div slot="header">
              <h5>{{ que.question }}</h5>
            </div>
            <p>{{ que.ans }}</p>
          </vs-collapse-item>
        </vs-collapse>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      faqSearchQuery: '',
      faqFilter: 1,
      categories: [
        {
          id: 1,
          name: 'All',
          color: 'grey',
        },
        {
          id: 2,
          name: 'General',
          color: 'primary',
        },
        {
          id: 3,
          name: 'Integration',
          color: 'success',
        },
        {
          id: 4,
          name: 'Personalization',
          color: 'warning',
        },
        // {
        //   id: 5,
        //   name: 'Trademark use',
        //   color: 'danger'
        // }
      ],
      faqs: [
        {
          id: 1,
          categoryId: 2,
          question: 'How do users access my artwork digital twin?',
          ans:
            'Hoverlay creates a mobile-friendly virtual gallery webpage for you, where a user can access all your digital twins from their phone or tablet.In addition, Hoverlay creates a direct link for each of your digital twins, which you can add to your artwork webpage or share via email or text.',
        },
        {
          id: 2,
          categoryId: 2,
          question: 'Does Hoverlay automatically scale my artwork or does the user have to take action?',
          ans:
            'Yes, the magic of Hoverlay is that it automatically calculates wall size and distance, and creates a size accurate 3D "twin" of your artwork based on the size you specify. Unlike earlier generations of Augmented Reality, no markers or user measurements are required.',
        },
        {
          id: 3,
          categoryId: 2,
          question: 'What devices does Hoverlay support?',
          ans:
            'Hoverlay works on any AR capable device. For iOS: iPhone 6s and above (released after Sept 2015), or any iPad 5th generation and above (released March 2017 or later), or iPad Pros. Full list at the bottom of this page: https://www.apple.com/ios/augmented-reality/) For Android: any phone that supports ARCore (https://developers.google.com/ar/discover/supported-devices)',
        },
        {
          id: 4,
          categoryId: 3,
          question: 'Can I add a "View In Your Space" button to my website?',
          ans: 'Yes. You can simply add the link to each artwork "digital twin" to a button on your product page.',
        },
        {
          id: 5,
          categoryId: 3,
          question: 'Does Hoverlay work with WooCommerce?',
          ans:
            'Yes,  we provide a plugin that will automatically add the button and link to your WooCommerce product page.',
        },
        {
          id: 6,
          categoryId: 3,
          question: 'Does Hoverlay work with WordPress?',
          ans: 'Yes,  Hoverlay provides an integration toolkit for Wordpress.',
        },
        {
          id: 7,
          categoryId: 3,
          question: 'What\s a return url and how can I customize it ? ',
          ans:
            'When viewing an artwork in AR via the Hoverlay app, you can customize the return URL Link so when the user click on the back button you can redirect hum to an webpage of your choice.',
        },
        {
          id: 8,
          categoryId: 3,
          question: 'Does Hoverlay work with commerce sites?',
          ans:
            'Yes, Hoverlay can connect to a CSV product feed, which can easily be generated from Shopify or other eCommerce platforms.',
        },
        {
          id: 9,
          categoryId: 4,
          question: ' Is there a way to change the virtual frame type and color?',
          ans: ' Is there a way to change the virtual frame type and color?',
        },
        {
          id: 9,
          categoryId: 2,
          question: 'Is Hoverlay available worldwide?',
          ans: 'Yes.',
        },
      ],
      supporters: [
        {
          id: 1,
          img: require('@/assets/images/portrait/small/avatar-s-1.jpg'),
          name: 'Boyce Shene',
          profession: 'Web Developer',
        },
        {
          id: 2,
          img: require('@/assets/images/portrait/small/avatar-s-2.jpg'),
          name: 'Margie Sevy',
          profession: 'Web Designer',
        },
        {
          id: 3,
          img: require('@/assets/images/portrait/small/avatar-s-3.jpg'),
          name: 'Cyndi Navas',
          profession: 'Web Developer',
        },
        {
          id: 4,
          img: require('@/assets/images/portrait/small/avatar-s-4.jpg'),
          name: 'Chi Petrusky',
          profession: 'Web Developer',
        },
        {
          id: 5,
          img: require('@/assets/images/portrait/small/avatar-s-5.jpg'),
          name: 'Shanel Dumag',
          profession: 'Web Designer',
        },
      ],
    }
  },
  computed: {
    filteredFaq() {
      return this.faqs.filter(faq => {
        if (this.faqFilter === 1)
          return (
            faq.question.toLowerCase().includes(this.faqSearchQuery.toLowerCase()) ||
            faq.ans.toLowerCase().includes(this.faqSearchQuery.toLowerCase())
          )
        else if (this.faqFilter === 2)
          return (
            faq.categoryId === 2 &&
            (faq.question.toLowerCase().includes(this.faqSearchQuery.toLowerCase()) ||
              faq.ans.toLowerCase().includes(this.faqSearchQuery.toLowerCase()))
          )
        else if (this.faqFilter === 3)
          return (
            faq.categoryId === 3 &&
            (faq.question.toLowerCase().includes(this.faqSearchQuery.toLowerCase()) ||
              faq.ans.toLowerCase().includes(this.faqSearchQuery.toLowerCase()))
          )
        else if (this.faqFilter === 4)
          return (
            faq.categoryId === 4 &&
            (faq.question.toLowerCase().includes(this.faqSearchQuery.toLowerCase()) ||
              faq.ans.toLowerCase().includes(this.faqSearchQuery.toLowerCase()))
          )
        else if (this.faqFilter === 5)
          return (
            faq.categoryId === 5 &&
            (faq.question.toLowerCase().includes(this.faqSearchQuery.toLowerCase()) ||
              faq.ans.toLowerCase().includes(this.faqSearchQuery.toLowerCase()))
          )
      })
    },
  },
  methods: {},
  components: {},
}
</script>

<style lang="scss">
#faq-page {
  .faq-jumbotron-content {
    background-image: url('../../../assets/images/pages/faq.jpg');
    background-size: cover;
  }

  .faq-bg {
    background-color: #fff;
  }
}
</style>
